// extracted by mini-css-extract-plugin
export default {"complianceDisclaimer":"Disclaimer__complianceDisclaimer-V_ZI","noWrap":"Disclaimer__noWrap-Mw9j"};